import { getI18n } from 'react-i18next';

export const ERROR_CASH_LIMIT_INVALID_SORT_KEY = 'cashLimit.sort.invalidField';

export const createCashLimitErrorMessage = (code, params) => { // NOSONAR javascript:S3800
    let result;
    const i18n = getI18n();
    if (code === ERROR_CASH_LIMIT_INVALID_SORT_KEY) {
        result = i18n.t('cash-limits.error.cash-limit-invalid-sort-key', { sortKey: params[0] });
    } else {
        result = undefined;
    }
    return result;
};
